import { useState } from 'react';
import { apiClient } from '../utils/apiClient';
import { API_CONFIG } from '../config/apiConfig';

export const useStageSerialNumbers = () => {
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState<string | null>(null);

  const stageSerialNumbers = async (serialJson: string) => {
    setLoading(true);
    setError(null);

    try {
      const response = await apiClient.post(API_CONFIG.ENDPOINTS.STAGE_SERIAL_NUMBERS, {
        p_serial_json: serialJson
      });

      if (!response.data.success) {
        throw new Error(response.data.error || 'Failed to stage serial numbers');
      }

      return response.data;
    } catch (err: any) {
      const errorMessage = err.message || 'Failed to stage serial numbers';
      setError(errorMessage);
      throw new Error(errorMessage);
    } finally {
      setLoading(false);
    }
  };

  return {
    stageSerialNumbers,
    loading,
    error
  };
};